export class StateName{
    code: string;
    name: string;
  }
  export class CountryState {
    country: string;
    states: StateName[];
  } 
export class CountryandState {
    
 CountrycodeJSON = 
    `{
        "AD": "Andorra",
        "AE": "United Arab Emirates",
        "AF": "Afghanistan",
        "AG": "Antigua and Barbuda",
        "AI": "Anguilla",
        "AL": "Albania",
        "AM": "Armenia",
        "AN": "Netherlands Antilles",
        "AO": "Angola",
        "AQ": "Antarctica",
        "AR": "Argentina",
        "AS": "American Samoa",
        "AT": "Austria",
        "AU": "Australia",
        "AW": "Aruba",
        "AX": "\u00c5land Islands",
        "AZ": "Azerbaijan",
        "BA": "Bosnia and Herzegovina",
        "BB": "Barbados",
        "BD": "Bangladesh",
        "BE": "Belgium",
        "BF": "Burkina Faso",
        "BG": "Bulgaria",
        "BH": "Bahrain",
        "BI": "Burundi",
        "BJ": "Benin",
        "BL": "Saint Barthélemy",
        "BM": "Bermuda",
        "BN": "Brunei Darussalam",
        "BO": "Bolivia, Plurinational State of",
        "BQ": "Caribbean Netherlands",
        "BR": "Brazil",
        "BS": "Bahamas",
        "BT": "Bhutan",
        "BV": "Bouvet Island",
        "BW": "Botswana",
        "BY": "Belarus",
        "BZ": "Belize",
        "CA": "Canada",
        "CC": "Cocos (Keeling) Islands",
        "CD": "Congo, the Democratic Republic of the",
        "CF": "Central African Republic",
        "CG": "Congo",
        "CH": "Switzerland",
        "CI": "C\u00f4te d'Ivoire",
        "CK": "Cook Islands",
        "CL": "Chile",
        "CM": "Cameroon",
        "CN": "China",
        "CO": "Colombia",
        "CR": "Costa Rica",
        "CU": "Cuba",
        "CV": "Cape Verde",
        "CW": "Cura\u00e7ao",
        "CX": "Christmas Island",
        "CY": "Cyprus",
        "CZ": "Czech Republic",
        "DE": "Germany",
        "DJ": "Djibouti",
        "DK": "Denmark",
        "DM": "Dominica",
        "DO": "Dominican Republic",
        "DZ": "Algeria",
        "EC": "Ecuador",
        "EE": "Estonia",
        "EG": "Egypt",
        "EH": "Western Sahara",
        "ER": "Eritrea",
        "ES": "Spain",
        "ET": "Ethiopia",
        "EU": "Europe",
        "FI": "Finland",
        "FJ": "Fiji",
        "FK": "Falkland Islands (Malvinas)",
        "FM": "Micronesia, Federated States of",
        "FO": "Faroe Islands",
        "FR": "France",
        "GA": "Gabon",
        "GB-ENG": "England",
        "GB-NIR": "Northern Ireland",
        "GB-SCT": "Scotland",
        "GB-WLS": "Wales",
        "GB": "United Kingdom",
        "GD": "Grenada",
        "GE": "Georgia",
        "GF": "French Guiana",
        "GG": "Guernsey",
        "GH": "Ghana",
        "GI": "Gibraltar",
        "GL": "Greenland",
        "GM": "Gambia",
        "GN": "Guinea",
        "GP": "Guadeloupe",
        "GQ": "Equatorial Guinea",
        "GR": "Greece",
        "GS": "South Georgia and the South Sandwich Islands",
        "GT": "Guatemala",
        "GU": "Guam",
        "GW": "Guinea-Bissau",
        "GY": "Guyana",
        "HK": "Hong Kong",
        "HM": "Heard Island and McDonald Islands",
        "HN": "Honduras",
        "HR": "Croatia",
        "HT": "Haiti",
        "HU": "Hungary",
        "ID": "Indonesia",
        "IE": "Ireland",
        "IL": "Israel",
        "IM": "Isle of Man",
        "IN": "India",
        "IO": "British Indian Ocean Territory",
        "IQ": "Iraq",
        "IR": "Iran, Islamic Republic of",
        "IS": "Iceland",
        "IT": "Italy",
        "JE": "Jersey",
        "JM": "Jamaica",
        "JO": "Jordan",
        "JP": "Japan",
        "KE": "Kenya",
        "KG": "Kyrgyzstan",
        "KH": "Cambodia",
        "KI": "Kiribati",
        "KM": "Comoros",
        "KN": "Saint Kitts and Nevis",
        "KP": "Korea, Democratic People's Republic of",
        "KR": "Korea, Republic of",
        "KW": "Kuwait",
        "KY": "Cayman Islands",
        "KZ": "Kazakhstan",
        "LA": "Lao People's Democratic Republic",
        "LB": "Lebanon",
        "LC": "Saint Lucia",
        "LI": "Liechtenstein",
        "LK": "Sri Lanka",
        "LR": "Liberia",
        "LS": "Lesotho",
        "LT": "Lithuania",
        "LU": "Luxembourg",
        "LV": "Latvia",
        "LY": "Libya",
        "MA": "Morocco",
        "MC": "Monaco",
        "MD": "Moldova, Republic of",
        "ME": "Montenegro",
        "MF": "Saint Martin",
        "MG": "Madagascar",
        "MH": "Marshall Islands",
        "MK": "Macedonia, the former Yugoslav Republic of",
        "ML": "Mali",
        "MM": "Myanmar",
        "MN": "Mongolia",
        "MO": "Macao",
        "MP": "Northern Mariana Islands",
        "MQ": "Martinique",
        "MR": "Mauritania",
        "MS": "Montserrat",
        "MT": "Malta",
        "MU": "Mauritius",
        "MV": "Maldives",
        "MW": "Malawi",
        "MX": "Mexico",
        "MY": "Malaysia",
        "MZ": "Mozambique",
        "NA": "Namibia",
        "NC": "New Caledonia",
        "NE": "Niger",
        "NF": "Norfolk Island",
        "NG": "Nigeria",
        "NI": "Nicaragua",
        "NL": "Netherlands",
        "NO": "Norway",
        "NP": "Nepal",
        "NR": "Nauru",
        "NU": "Niue",
        "NZ": "New Zealand",
        "OM": "Oman",
        "PA": "Panama",
        "PE": "Peru",
        "PF": "French Polynesia",
        "PG": "Papua New Guinea",
        "PH": "Philippines",
        "PK": "Pakistan",
        "PL": "Poland",
        "PM": "Saint Pierre and Miquelon",
        "PN": "Pitcairn",
        "PR": "Puerto Rico",
        "PS": "Palestine",
        "PT": "Portugal",
        "PW": "Palau",
        "PY": "Paraguay",
        "QA": "Qatar",
        "RE": "Réunion",
        "RO": "Romania",
        "RS": "Serbia",
        "RU": "Russian Federation",
        "RW": "Rwanda",
        "SA": "Saudi Arabia",
        "SB": "Solomon Islands",
        "SC": "Seychelles",
        "SD": "Sudan",
        "SE": "Sweden",
        "SG": "Singapore",
        "SH": "Saint Helena, Ascension and Tristan da Cunha",
        "SI": "Slovenia",
        "SJ": "Svalbard and Jan Mayen Islands",
        "SK": "Slovakia",
        "SL": "Sierra Leone",
        "SM": "San Marino",
        "SN": "Senegal",
        "SO": "Somalia",
        "SR": "Suriname",
        "SS": "South Sudan",
        "ST": "Sao Tome and Principe",
        "SV": "El Salvador",
        "SX": "Sint Maarten (Dutch part)",
        "SY": "Syrian Arab Republic",
        "SZ": "Swaziland",
        "TC": "Turks and Caicos Islands",
        "TD": "Chad",
        "TF": "French Southern Territories",
        "TG": "Togo",
        "TH": "Thailand",
        "TJ": "Tajikistan",
        "TK": "Tokelau",
        "TL": "Timor-Leste",
        "TM": "Turkmenistan",
        "TN": "Tunisia",
        "TO": "Tonga",
        "TR": "Turkey",
        "TT": "Trinidad and Tobago",
        "TV": "Tuvalu",
        "TW": "Taiwan",
        "TZ": "Tanzania, United Republic of",
        "UA": "Ukraine",
        "UG": "Uganda",
        "UM": "US Minor Outlying Islands",
        "US": "United States",
        "UY": "Uruguay",
        "UZ": "Uzbekistan",
        "VA": "Holy See (Vatican City State)",
        "VC": "Saint Vincent and the Grenadines",
        "VE": "Venezuela, Bolivarian Republic of",
        "VG": "Virgin Islands, British",
        "VI": "Virgin Islands, U.S.",
        "VN": "Viet Nam",
        "VU": "Vanuatu",
        "WF": "Wallis and Futuna Islands",
        "XK": "Kosovo",
        "WS": "Samoa",
        "YE": "Yemen",
        "YT": "Mayotte",
        "ZA": "South Africa",
        "ZM": "Zambia",
        "ZW": "Zimbabwe"
    }`;

    StateByCountryJSON = `{
    "countries": [
        {
            "country":"US",
            "states": [
            {
                "code"  :"AL",
                "name":"Alabama"
            },
            {
                "code"  :"AK",
                "name":"Alaska"
            },
            {
                "code"  :"AS",
                "name":"American Samoa"
            },
            {
                "code"  :"AZ",
                "name":"Arizona"
            },
            {
                "code"  :"AR",
                "name":"Arkansas"
            },
            {
                "code"  :"CA",
                "name":"California"
            },
            {
                "code"  :"CO",
                "name":"Colorado"
            },
            {
                "code"  :"CT",
                "name":"Connecticut"
            },
            {
                "code"  :"DE",
                "name":"Delaware"
            },
            {
                "code"  :"DC",
                "name":"District Of Columbia"
            },
            {
                "code"  :"FM",
                "name":"Federated States Of Micronesia"
            },
            {
                "code"  :"FL",
                "name":"Florida"
            },
            {
                "code"  :"GA",
                "name":"Georgia"
            },
            {
                "code"  :"GU",
                "name":"Guam"
            },
            {
                "code"  :"HI",
                "name":"Hawaii"
            },
            {
                "code"  :"ID",
                "name":"Idaho"
            },
            {
                "code"  :"IL",
                "name":"Illinois"
            },
            {
                "code"  :"IN",
                "name":"Indiana"
            },
            {
                "code"  :"IA",
                "name":"Iowa"
            },
            {
                "code"  :"KS",
                "name":"Kansas"
            },
            {
                "code"  :"KY",
                "name":"Kentucky"
            },
            {
                "code"  :"LA",
                "name":"Louisiana"
            },
            {
                "code"  :"ME",
                "name":"Maine"
            },
            {
                "code"  :"MH",
                "name":"Marshall Islands"
            },
            {
                "code"  :"MD",
                "name":"Maryland"
            },
            {
                "code"  :"MA",
                "name":"Massachusetts"
            },
            {
                "code"  :"MI",
                "name":"Michigan"
            },
            {
                "code"  :"MN",
                "name":"Minnesota"
            },
            {
                "code"  :"MS",
                "name":"Mississippi"
            },
            {
                "code"  :"MO",
                "name":"Missouri"
            },
            {
                "code"  :"MT",
                "name":"Montana"
            },
            {
                "code"  :"NE",
                "name":"Nebraska"
            },
            {
                "code"  :"NV",
                "name":"Nevada"
            },
            {
                "code"  :"NH",
                "name":"New Hampshire"
            },
            {
                "code"  :"NJ",
                "name":"New Jersey"
            },
            {
                "code"  :"NM",
                "name":"New Mexico"
            },
            {
                "code"  :"NY",
                "name":"New York"
            },
            {
                "code"  :"NC",
                "name":"North Carolina"
            },
            {
                "code"  :"ND",
                "name":"North Dakota"
            },
            {
                "code"  :"MP",
                "name":"Northern Mariana Islands"
            },
            {
                "code"  :"OH",
                "name":"Ohio"
            },
            {
                "code"  :"OK",
                "name":"Oklahoma"
            },
            {
                "code"  :"OR",
                "name":"Oregon"
            },
            {
                "code"  :"PW",
                "name":"Palau"
            },
            {
                "code"  :"PA",
                "name":"Pennsylvania"
            },
            {
                "code"  :"PR",
                "name":"Puerto Rico"
            },
            {
                "code"  :"RI",
                "name":"Rhode Island"
            },
            {
                "code"  :"SC",
                "name":"South Carolina"
            },
            {
                "code"  :"SD",
                "name":"South Dakota"
            },
            {
                "code"  :"TN",
                "name":"Tennessee"
            },
            {
                "code"  :"TX",
                "name":"Texas"
            },
            {
                "code"  :"UT",
                "name":"Utah"
            },
            {
                "code"  :"VT",
                "name":"Vermont"
            },
            {
                "code"  :"VI",
                "name":"Virgin Islands"
            },
            {
                "code"  :"VA",
                "name":"Virginia"
            },
            {
                "code"  :"WA",
                "name":"Washington"
            },
            {
                "code"  :"WV",
                "name":"West Virginia"
            },
            {
                "code"  :"WI",
                "name":"Wisconsin"
            },
            {
                "code"  :"WY",
                "name":"Wyoming"
            }
        ]
    },
    {
        "country":"IN",
        "states":[
            {
                "code"  :"AN",
                "name":"Andaman and Nicobar Islands"
            },
            {
                "code"  :"AP",
                "name":"Andhra Pradesh"
            },
            {
                "code"  :"AR",
                "name":"Arunachal Pradesh"
            },
            {
                "code"  :"AS",
                "name":"Assam"
            },
            {
                "code"  :"BR",
                "name":"Bihar"
            },
            {
                "code"  :"CG",
                "name":"Chandigarh"
            },
            {
                "code"  :"CH",
                "name":"Chhattisgarh"
            },
            {
                "code"  :"DN",
                "name":"Dadra and Nagar Haveli"
            },
            {
                "code"  :"DD",
                "name":"Daman and Diu"
            },
            {
                "code"  :"DL",
                "name":"Delhi"
            },
            {
                "code"  :"GA",
                "name":"Goa"
            },
            {
                "code"  :"GJ",
                "name":"Gujarat"
            },
            {
                "code"  :"HR",
                "name":"Haryana"
            },
            {
                "code"  :"HP",
                "name":"Himachal Pradesh"
            },
            {
                "code"  :"JK",
                "name":"Jammu and Kashmir"
            },
            {
                "code"  :"JH",
                "name":"Jharkhand"
            },
            {
                "code"  :"KA",
                "name":"Karnataka"
            },
            {
                "code"  :"KL",
                "name":"Kerala"
            },
            {
                "code"  :"LA",
                "name":"Ladakh"
            },
            {
                "code"  :"LD",
                "name":"Lakshadweep"
            },
            {
                "code"  :"MP",
                "name":"Madhya Pradesh"
            },
            {
                "code"  :"MH",
                "name":"Maharashtra"
            },
            {
                "code"  :"MN",
                "name":"Manipur"
            },
            {
                "code"  :"ML",
                "name":"Meghalaya"
            },
            {
                "code"  :"MZ",
                "name":"Mizoram"
            },
            {
                "code"  :"NL",
                "name":"Nagaland"
            },
            {
                "code"  :"OR",
                "name":"Odisha"
            },
            {
                "code"  :"PY",
                "name":"Puducherry"
            },
            {
                "code"  :"PB",
                "name":"Punjab"
            },
            {
                "code"  :"RJ",
                "name":"Rajasthan"
            },
            {
                "code"  :"SK",
                "name":"Sikkim"
            },
            {
                "code"  :"TN",
                "name":"Tamil Nadu"
            },
            {
                "code"  :"TS",
                "name":"Telangana"
            },
            {
                "code"  :"TR",
                "name":"Tripura"
            },
            {
                "code"  :"UP",
                "name":"Uttar Pradesh"
            },
            {
                "code"  :"UK",
                "name":"Uttarakhand"
            },
            {
                "code"  :"WB",
                "name":"West Bengal"
            }
        ]
    }
]
}`;
             
 
}
